"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleDataRows = exports.simpleExpandableHeader = exports.simpleHeader = void 0;
/** A const for a marker header row. */
exports.simpleHeader = { kind: "header", id: "header", data: undefined };
exports.simpleExpandableHeader = { kind: "expandableHeader", id: "expandableHeader", data: undefined };
/** Like `simpleRows` but for `SimpleHeaderAndData`. */
function simpleDataRows(data = []) {
    // @ts-ignore Not sure why this doesn't type-check, something esoteric with the DiscriminateUnion type
    return [exports.simpleHeader, ...data.map((data) => ({ kind: "data", data, id: data.id }))];
}
exports.simpleDataRows = simpleDataRows;
